export const mainContainer = () => ({});

export const container = ({ width, slides, translate, transitionDuration }) => ({
    width: width * slides.length,
    display: 'flex',
    transform: `translateX(${translate}px)`,
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s`,
    willChange: 'transform',
});

export const extendStepNavContainer = {
    container: () => ({
        position: 'absolute',
        width: '100%',
        zIndex: 2,
    }),
};

export const extendStepNavFluidContainer = {
    container: () => ({
        paddingTop: '1rem',
        paddingBottom: 0,
        tabletLarge: {
            paddingTop: '3.6875rem',
            display: 'flex',
        },
    }),
};

export const extendText = {
    text: ({ theme: { colors } }) => ({
        color: colors.white,
        alignSelf: 'center',
        flex: 1,
    }),
};

export const extendButton = {
    button: () => ({
        position: 'absolute',
        bottom: '1.5rem',
        right: '3.5rem',
    }),
};

export const navigationContainer = () => ({
    top: '70%',
    right: '1.5rem',

    tablet: {
        right: 0,
    },

    tabletLarge: {
        top: '50%',
    },
});
